import invariant from 'invariant';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type Sections =
  | 'actions'
  | 'ai'
  | 'apps'
  | 'billing'
  | 'branding'
  | 'content-security'
  | 'fields'
  | 'groups'
  | 'labs'
  | 'notifications'
  | 'plan'
  | 'profile'
  | 'projects'
  | 'share-link-security'
  | 'share-lists'
  | 'storage'
  | 'usage'
  | 'users'
  | 'webhooks'
  | 'workspace'
  | 'workspaces';

export type SettingsGetLinkParams = {
  page: 'settings';
} & (
  | { section: Sections }
  | {
      section: 'projects';
      filter?: {
        accountUserId?: string;
        status?: 'active' | 'inactive';
        storage?: 'mounted' | 'standard' | 'disabled';
        workspaceId?: string;
      };
    }
);

export function getLinkForSettings(params: SettingsGetLinkParams): ValidHref {
  const { section } = params;
  const searchParams: { [key: string]: string } = {};

  invariant(section, 'section is required');

  if (section === 'projects' && 'filter' in params) {
    const filter = params.filter || {};
    if (filter.status) {
      searchParams.status = filter.status;
    }
    if (filter.storage) {
      searchParams.storage = filter.storage;
    }
    if (filter.workspaceId) {
      searchParams.w = filter.workspaceId;
    }
    if (filter.accountUserId) {
      searchParams.au = filter.accountUserId;
    }
  }

  return createUrl({
    pathname: `/settings/${section}`,
    searchParams,
  });
}

export const isSettingsPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  if (parts[1] === 'settings') {
    return true;
  }
  return false;
};
